import { useQuery } from '@tanstack/react-query';
import {
  getAllWorkShifts,
  getWorkShiftsPaged,
  WorkShiftListDto,
  WorkShiftListParams,
  WorkShiftListResult,
} from '../services/workShiftService';
import { configurationKeys } from '../queryKeys';

export function useShifts(tenantId: string) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<
    WorkShiftListDto[],
    Error
  >({
    queryKey: configurationKeys.shifts.list(tenantId),
    queryFn: () => getAllWorkShifts(tenantId),
    enabled: Boolean(tenantId),
    staleTime: 30_000,
  });

  return {
    shifts: data ?? [],
    isLoading,
    isFetching,
    isError,
    error: error ?? null,
    refetch,
  };
}

/**
 * Server-side paginated/searchable variant, used only by the Shifts Configuration
 * screen's table. `useShifts` above is left untouched — it still serves dropdown
 * selects elsewhere unpaginated.
 */
export function useShiftsList(params: WorkShiftListParams) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<
    WorkShiftListResult,
    Error
  >({
    queryKey: configurationKeys.shifts.paged(params),
    queryFn: () => getWorkShiftsPaged(params),
    enabled: Boolean(params.tenantId),
    staleTime: 30_000,
    placeholderData: (previous) => previous,
  });

  return {
    shifts: data?.items ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isFetching,
    isError,
    error: error ?? null,
    refetch,
  };
}
